import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import InvoiceInfoHeader from "./InvoiceInfoHeader";
import { Table, TableBody, TableRow } from "@mui/material";
import borders from "assets/theme/base/borders";
import colors from "assets/theme/base/colors";
import Helpers from "utils/Helpers";

function InvoicePOSInfo({ payment }) {
  const { borderWidth } = borders;
  const { light } = colors;
  const borderBottom = `${borderWidth[1]} solid ${light.main}`;
  const fontSize = "8pt";

  return payment !== null ? (
    <SoftBox p={1}>
      <InvoiceInfoHeader title={"POS"} />
      <SoftBox width="100%" overflow="auto">
        <Table sx={{ minWidth: "32rem" }}>
          <SoftBox component="thead">
            <TableRow>
              <SoftBox
                component="th"
                py={1.5}
                pl={3}
                pr={1}
                textAlign="left"
                width={{ xs: "10%" }}
                borderBottom={borderBottom}
              >
                <SoftTypography variant="h6" color="text" fontWeight="medium" fontSize={"10pt"}>
                  Ημερομηνία
                </SoftTypography>
              </SoftBox>
              <SoftBox
                component="th"
                width={{ xs: "5%" }}
                py={1.5}
                px={1}
                textAlign="left"
                borderBottom={borderBottom}
              >
                <SoftTypography variant="h6" color="text" fontWeight="medium" fontSize={"10pt"}>
                  TID
                </SoftTypography>
              </SoftBox>
              <SoftBox
                component="th"
                py={1.5}
                pl={3}
                pr={1}
                width={{ xs: "5%" }}
                textAlign="left"
                borderBottom={borderBottom}
              >
                <SoftTypography variant="h6" color="text" fontWeight="medium" fontSize={"10pt"}>
                  Transaction ID
                </SoftTypography>
              </SoftBox>
              <SoftBox
                component="th"
                py={1.5}
                pl={3}
                pr={1}
                textAlign="left"
                width={{ xs: "5%" }}
                borderBottom={borderBottom}
              >
                <SoftTypography variant="h6" color="text" fontWeight="medium" fontSize={"10pt"}>
                  Ποσό Πληρωμής
                </SoftTypography>
              </SoftBox>
              <SoftBox
                component="th"
                py={1.5}
                pl={3}
                pr={1}
                textAlign="left"
                width={{ xs: "5%" }}
                borderBottom={borderBottom}
              >
                <SoftTypography variant="h6" color="text" fontWeight="medium" fontSize={"10pt"}>
                  Φιλοδώρημα
                </SoftTypography>
              </SoftBox>
              <SoftBox
                component="th"
                py={1.5}
                pl={3}
                pr={1}
                textAlign="left"
                width={{ xs: "30%" }}
                borderBottom={borderBottom}
              >
                <SoftTypography variant="h6" color="text" fontWeight="medium" fontSize={"10pt"}>
                  Υπογραφή Πληρωμής
                </SoftTypography>
              </SoftBox>
            </TableRow>
          </SoftBox>{" "}
          <TableBody>
            <TableRow>
              <SoftBox
                component="td"
                textAlign="left"
                py={1}
                pr={1}
                pl={3}
                borderBottom={borderBottom}
              >
                <SoftTypography variant="body2" color="text" fontSize={fontSize}>
                  {Helpers.formatDateToNormal(payment.issueDateTime)}
                </SoftTypography>
              </SoftBox>
              <SoftBox component="td" textAlign="left" p={1} borderBottom={borderBottom}>
                <SoftTypography variant="body2" color="text" fontSize={fontSize}>
                  {payment.terminalId}
                </SoftTypography>
              </SoftBox>
              <SoftBox
                component="td"
                textAlign="left"
                py={1}
                pr={1}
                pl={3}
                borderBottom={borderBottom}
              >
                <SoftTypography variant="body2" color="text" fontSize={fontSize}>
                  {payment.transactionId}
                </SoftTypography>
              </SoftBox>
              <SoftBox
                component="td"
                textAlign="left"
                py={1}
                pr={1}
                pl={3}
                borderBottom={borderBottom}
              >
                <SoftTypography variant="body2" color="text" fontSize={fontSize}>
                  {payment.amount ? payment.amount.toFixed(2) : ""}
                </SoftTypography>
              </SoftBox>
              <SoftBox
                component="td"
                textAlign="left"
                py={1}
                pr={1}
                pl={3}
                borderBottom={borderBottom}
              >
                <SoftTypography variant="body2" color="text" fontSize={fontSize}>
                  {payment.tipAmount ? payment.tipAmount.toFixed(2) : ""}
                </SoftTypography>
              </SoftBox>
              <SoftBox
                component="td"
                textAlign="left"
                py={1}
                pr={1}
                pl={3}
                borderBottom={borderBottom}
              >
                <SoftTypography
                  variant="body2"
                  color="text"
                  fontSize={fontSize}
                  style={{ "word-break": "break-all" }}
                >
                  {payment.hexSignature}
                </SoftTypography>
              </SoftBox>
            </TableRow>
          </TableBody>
        </Table>
      </SoftBox>
    </SoftBox>
  ) : (
    ""
  );
}

export default InvoicePOSInfo;
